module.exports = __webpack_public_path__ + "static/milanka-video-bg-cb0c064d3953d22809ea773b50d47518.png";